module.exports = __webpack_public_path__ + "static/media/ae2.3d01bc8e.png";